import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationSubtype, ApplicationType } from "@duosoftbg/nacid-components";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/seOfficialNoteForm";
import { Box } from "@mui/material";

const SEOfficialNoteStepDocuments = () => {
  const seOfficialNoteForm = useAppSelector((state) => {
    return state.Forms.SEOfficialNoteForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    seOfficialNoteForm,
    baseEndpointPaths.seRecognition,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seOfficialNoteForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={seOfficialNoteForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.rudi.files.info", "m.seServices.applications.info"]}
      applicationType={ApplicationType.SE_RECOGNITION}
      applicationSubType={ApplicationSubtype.SE_RECOGNITION}
    />
  );
};
export default SEOfficialNoteStepDocuments;
